import React from 'react';
import { TouchableOpacity } from 'react-native';
import OpenEyeIcon from '../../../../shared/assets/icons/openEyeIcon';
import CloseEyeIcon from '../../../../shared/assets/icons/closeEyeIcon';

interface PasswordToggleButtonProps {
  isPasswordVisible: boolean;
  onPress: () => void;
  style: object;
  openEyeIconColor: string;
  closeEyeIconColor: string;
  hidePasswordLabel: string;
  showPasswordLabel: string;
}

/**
 * Renders the show/hide password eye-icon button.
 * Shared between Input (native) and Input.web.
 */
const PasswordToggleButton: React.FC<PasswordToggleButtonProps> = ({
  isPasswordVisible,
  onPress,
  style,
  openEyeIconColor,
  closeEyeIconColor,
  hidePasswordLabel,
  showPasswordLabel,
}) => (
  <TouchableOpacity
    style={style}
    onPress={onPress}
    activeOpacity={0.7}
    testID="secureTextEntryId"
    accessibilityRole="button"
    accessibilityLabel={isPasswordVisible ? hidePasswordLabel : showPasswordLabel}
  >
    {isPasswordVisible ? (
      <OpenEyeIcon color={openEyeIconColor} />
    ) : (
      <CloseEyeIcon color={closeEyeIconColor} />
    )}
  </TouchableOpacity>
);

export default PasswordToggleButton;